import { FC, MouseEvent, ReactNode, useState } from 'react'

import styled from 'styled-components'

import CheckMarkIcon from 'src/Assets/Svg/referAndEarn/success.svg?react'
import { CTAButton } from 'src/Components/Buttons/CTAButton'

interface CopyButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: ReactNode
  value: string
  copiedText: ReactNode
}

const StyledButton = styled(CTAButton)`
  width: 100%;
  white-space: nowrap;
`

const CopiedText = styled.div`
  display: flex;
  height: 40px;
  align-items: center;
  justify-content: center;
  gap: 8px;
  align-self: stretch;
  color: ${({ theme }) => theme.color.brandGreen};
  font-size: 14px;
  font-weight: 400;
  line-height: 150%;
  padding: 9.5px 32px;
`

export const CopyButton: FC<CopyButtonProps> = (props) => {
  const { children, value, copiedText, onClick, className, ...restProps } =
    props
  const [copied, setCopied] = useState(false)

  const handleClick = async (
    e: MouseEvent<HTMLButtonElement>,
  ): Promise<void> => {
    await window.navigator.clipboard.writeText(value)
    onClick && onClick(e)
    setCopied(true)
  }

  if (copied) {
    return (
      <CopiedText className={className}>
        <CheckMarkIcon data-testid='copied-icon' />
        {copiedText}
      </CopiedText>
    )
  }

  return (
    <StyledButton {...restProps} className={className} onClick={handleClick}>
      {children}
    </StyledButton>
  )
}
